<div class="d-flex gap-3">
    <i class="icon" [ngClass]="icon" *ngIf="icon"></i>
    <div class="d-flex flex-column w-100">
        <p class="title mb-1" *ngIf="title">{{ title }}</p>
        <div class="d-flex gap-2" *ngIf="calculation || calculation === 0">
            <p class="calculation mb-0">
                {{ calculation | currency : currency}}
            </p>
            <p class="period-name mb-0" *ngIf="periodName">
                {{periodName}}
            </p>
        </div>
        <div class="d-flex flex-column gap-2 w-100" *ngIf="detailedCalculation?.length">
            <div class="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center w-100" *ngFor="let item of detailedCalculation">
                <p class="detailed-calculation-label mb-0">
                    {{item.label}}
                </p>
                <p class="detailed-calculation-value mb-0">
                    {{ item.value | currency : currency}}
                </p>
            </div>
            <div class="d-flex flex-column flex-md-row justify-content-md-between mt-3" *ngIf="calculationSummary">
                <p class="mb-0">
                    {{calculationSummary.label}}
                </p>
                <p class="detailed-calculation-value mb-0">
                    <strong>{{ calculationSummary.value | currency : currency}}</strong>
                </p>
            </div>
        </div>
    </div>
</div>